import React from "react";

const FAQ_ITEMS = [
  {
    q: "Why become a Freemason?",
    a: (
      <p>
        People join Freemasonry for many different reasons, some join for the
        friendships they will make; friendships that last a lifetime and encompass the
        key milestones in life for better or worse. You will meet people who are
        different to you, those of different ages with radically different life
        experiences and interests, drawn together by common experience through
        Freemasonry. Our members are, and have been for three centuries, drawn from all
        walks of life. From Captains of industry and chief executives to manual
        labourers and forklift truck drivers, so you will find people with a wealth of
        different outlooks from all races, religions, classes and backgrounds. There
        are also those who enjoy the ceremonial aspects. Our meetings consist of
        centuries old lessons centered around you as an individual. How you live your
        life, the decisions that you make and how to become a better person are all
        found within our meetings. Freemasons are taught to look after those less
        fortunate than themselves, charity is our lifeblood and many members devote
        their time and energy to helping those less fortunate than themselves. We also
        have a huge amount of fun along the way, we eat, drink and meet together and
        form lifelong friendships.
      </p>
    ),
  },
  {
    q: "Do you have to believe in God?",
    a: (
      <p>
        A belief in a 'supreme being' is a requirement. Freemasons generally believe in
        a God - be it Christian, Muslim, Sikh or Jewish etc - of some sort, even if
        they do not necessarily practice any particular religion.
      </p>
    ),
  },
  {
    q: "What goes on in a lodge meeting?",
    a: (
      <p>
        There are three 'degree ceremonies' performed during masonic meetings. They are
        essentially one act plays and teach members how to be better people and each
        play represents a different stage in life. As an 'initiate' or Entered
        Apprentice, Freemasons are taught we are all born equal, we learn that in life
        some do better than others and it is up to those that do well to look after the
        less fortunate. From this stems our belief in the importance of Charity. The
        next stage is to become a 'Fellow Craft' where Freemasons are taught the
        importance of improving yourself as a person, and finally as a 'Master Mason',
        where we learn that we have but one life, and the importance of using it
        wisely. The details of the ceremonies can easily be accessed online but nothing
        beats experiencing it for yourself. After the meetings members dine together
        informally in order to enjoy good food, good wine, and good company. And most
        importantly, to have fun together.
      </p>
    ),
  },
  {
    q: "Why do freemasons wear approns?",
    a: (
      <p>
        The aprons stem from our historical and symbolic roots as stonemasons. Being
        leather, they were designed to protect them from sharp tools and rough stones.
        For today's Freemasons, the apron is a mark of their membership. They are
        presented with a white leather apron and as they progress this becomes more
        elaborate.
      </p>
    ),
  },
  {
    q: "Can women be freemasons?",
    a: (
      <p>
        Only men aged over 18 are allowed to join the United Grand Lodge of England in
        England and Wales.
        <br />
        The two leading women's Grand Lodges, that we have the closest relationship,
        with are:{" "}
        <a href="https://hfaf.org/" target="_blank" rel="noreferrer">
          Freemasonry for Women
        </a>{" "}
        and the{" "}
        <a href="https://www.owf.org.uk/" target="_blank" rel="noreferrer">
          Order of Women Freemasons
        </a>
        . These two groups only admit women because that is the choice of their
        memberships. Both of the women's organisations, and ourselves, prefer to
        practice our Freemasonry in single sex environments. The{" "}
        <a href="https://www.ugle.org.uk/" target="_blank" rel="noreferrer">
          United Grand Lodge of England
        </a>{" "}
        regularly hires its facilities out for meetings of the two women's Lodges due
        to our mutual respect and close relations.
      </p>
    ),
  },
  {
    q: "What is different about the way freemasons give to charity?",
    a: (
      <>
        <p>
          It is the sheer scale.
          <br />
          We are one of the biggest charitable givers in the country and gave gave
          £51.1m to charities in 2020 alone. The{" "}
          <a href="https://mcf.org.uk/" target="_blank" rel="noreferrer">
            Masonic Charitable Foundation
          </a>
          , the Freemasons' Charity – our national charitable grant giving arm, tackles
          some of the most significant challenges facing society, in particular,
          reducing loneliness in later life and ensuring a positive future for young
          children. We work in partnership with some of the biggest charities in the
          country to deliver our support. Freemasonry also does a huge amount for
          medical research into treatments for cancer, diabetes, heart disease and a
          whole range of other conditions. In addition it makes donations to support
          those affected by overseas disasters as well as those at home, such as the
          Grenfell Tower disaster. During the Covid Pandemic Freemasons working
          together to help their communities. The United Grand Lodge of England, and
          its members, are doing all they can to help in the fight the coronavirus.
        </p>
        <p>
          We have seen remarkable stories from across the country of how our members
          came together – from helping to raise vital funds for the NHS and delivering
          food to the community, through to purchasing ambulances and manufacturing
          vital personal protective equipment (PPE). To support Freemasonry's
          charitable response to the coronavirus pandemic, UGLE and the Masonic
          Charitable Foundation, the Freemasons' charity, established the Freemasons'
          COVID-19 Community Fund. This Fund has helped to support a range of local and
          national charities and projects that are helping people through the current
          coronavirus pandemic and in total has donated £3m during the pandemic.
        </p>
      </>
    ),
  },
  {
    q: "Is freemasonry international?",
    a: (
      <p>
        Freemasonry exists throughout the world and the{" "}
        <a href="https://www.ugle.org.uk/" target="_blank" rel="noreferrer">
          United Grand Lodge of England
        </a>{" "}
        has Districts in many oversees countries. Our members are free to visit any of
        our Lodges abroad and will often find a warm welcome from fellow members who
        know the local country very well.
        <br />
        In addition to our Lodges, many other counties have sovereign grand lodges,
        which our members are free to visit and whose members visit us in England and
        Wales when travelling.
      </p>
    ),
  },
  {
    q: "How many freemasons are in the world?",
    a: (
      <p>
        The{" "}
        <a href="https://www.ugle.org.uk/" target="_blank" rel="noreferrer">
          United Grand Lodge of England
        </a>{" "}
        has 180,000 members. The{" "}
        <a
          href="https://www.grandlodgescotland.com/"
          target="_blank"
          rel="noreferrer"
        >
          Grand Lodge of Scotland
        </a>{" "}
        and{" "}
        <a href="https://freemason.ie/" target="_blank" rel="noreferrer">
          Ireland
        </a>{" "}
        also have 10,000 members and the two female grand lodges in England comprise of
        around 25,000 members. Worldwide there are estimated to be around six million
        members.
      </p>
    ),
  },
  {
    q: "How much does it cost to become a freemason?",
    a: (
      <p>
        On average the annual dues and other fees amount to £200 a year, although there
        are local variations.
      </p>
    ),
  },
];

function FAQ() {
  return (
    <section id="faq" className="section">
      <div className="container">
        <div style={{ maxWidth: "65ch" }}>
          <p className="eyebrow">Frequently asked</p>
          <h2>Questions, answered.</h2>
          <p className="lede">
            What's a lodge meeting like? Do you have to believe in God? Can women be
            Freemasons? We've answered the questions we hear most often.
          </p>
        </div>
        <div className="faq">
          {FAQ_ITEMS.map((item, i) => (
            <details key={i}>
              <summary>
                <span>{item.q}</span>
                <span className="icon" aria-hidden="true"></span>
              </summary>
              <div className="faq__content">{item.a}</div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
